import React, { useEffect } from "react";
import Hero from "./Hero/Hero";
import Footer from "../../Components/Footer/Footer";
import TextContent from "./TextContent/TextContent";
import JCarousel from "./JCarousel/JCarousel";
import Form from "./Form/DonationForm";
import Qrcodes from "./QRCodes/Qrcodes.jsx";
import { Helmet } from "react-helmet-async";

const Kartik2025 = () => {
  const eventSchema = {
    "@context": "https://schema.org",
    "@type": "Event",
    name: "ISKCON Vijayawada Kertik Maas 2025",
    startDate: "2025-08-16T23:49:00+05:30",
    endDate: "2025-08-17T00:34:00+05:30",
    eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
    eventStatus: "https://schema.org/EventScheduled",
    location: {
      "@type": "Place",
      name: "ISKCON Vijayawada Temple",
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "ISKCON Sri Jagannath Mandir, Skew Bridge, Ramalingeswara Nagar",
        addressLocality: "Vijayawada",
        addressRegion: "Andhra Pradesh",
        postalCode: "520013",
        addressCountry: "IN",
      },
    },
    organizer: {
      "@type": "Organization",
      name: "ISKCON Vijayawada",
      url: "https://www.iskconvijayawada.org/",
    },
    description:
      "Celebration of Sri Krishna Janmashtami with Nishita Puja (midnight puja), kirtan & rituals at ISKCON Vijayawada.",
    image: [
      "https://www.iskconvijayawada.org/path-to-image1.jpg",
      "https://www.iskconvijayawada.org/path-to-image2.jpg",
    ],
    offers: {
      "@type": "Offer",
      url: "https://www.iskconvijayawada.org/janmashtami2025",
      availability: "https://schema.org/InStock",
      price: "0",
      priceCurrency: "INR",
    },
    performer: {
      "@type": "Organization",
      name: "ISKCON Vijayawada",
    },
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Helmet>
        <title>
          Kertik Mass 2025 – Celebrate Sri Krishna’s Appearance Day | ISKCON
          Vijayawada
        </title>
        <meta
          name="description"
          content="Join ISKCON Vijayawada for the divine Janmashtami 2025 celebration with bhajans, pujas, prasadam, and cultural events."
        />
        <meta
          name="keywords"
          content="ISKCON Vijayawada Janmashtami, Janmashtami ISKCON Vijayawada, Janmashtami ISKCON, Janmashtami celebrations at ISKCON Vijayawada, Janmashtami pooja ISKCON Vijayawada, ISKCON Vijayawada festivals, Lord krishana festival ISKCON, Janmashtami 2025 ISKCON,Janmashtami 2025 Vijayawada,Janmashtami puja ISKCON Vijayawada, Janmashtami ISKCON, Narasimha Chaturdashi ritual Vijayawada, ISKCON spiritual events Vijayawada, Narasimha Chaturdashi significance ISKCON, Narasimha avatar celebration ISKCON"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="Janmashtami 2025 – Celebrate Sri Krishna’s Appearance Day | ISKCON Vijayawada"
        />
        <meta
          property="og:description"
          content="Join ISKCON Vijayawada for the divine Janmashtami 2025 celebration with bhajans, pujas, prasadam, and cultural events."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content=" https://www.iskconvijayawada.org/janmashtami2025 "
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Janmashtami 2025 – Celebrate Sri Krishna’s Appearance Day | ISKCON Vijayawada"
        />
        <meta
          name="twitter:description"
          content="Join ISKCON Vijayawada for the divine Janmashtami 2025 celebration with bhajans, pujas, prasadam, and cultural events."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/janmashtami2025"
        />

        {/* <script type="application/ld+json">
          {`
                    {
                        "@context": "https://schema.org",
                        "@type": "Event",
                        "name": "ISKCON Vijayawada Janmashtami 2025",
                        "alternateName": "Janmashtami Vijayawada",
                        "startDate": "2025-07-27T08:00:00+05:30",
                        "endDate": "2025-07-29T18:00:00+05:30",
                        "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
                        "eventStatus": "https://schema.org/EventScheduled",
                        "location": {
                        "@type": "Place",
                        "name": "ISKCON Vijayawada",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "29-12-7, Nakkala Road, Suryaraopeta",
                            "addressLocality": "Vijayawada",
                            "addressRegion": "Andhra Pradesh",
                            "postalCode": "520002",
                            "addressCountry": "IN"
                        }
                        },
                        "image": [
                        "https://www.iskconvijayawada.org/wp-content/uploads/2024/06/rathyatra-banner.webp"
                        ],
                        "description": "Join us for the grand ISKCON Vijayawada Ratha Yatra 2025 – a spiritual procession of Lord Jagannath, Baladev, and Subhadra Devi through the streets of Vijayawada. Kirtan, prasadam, and devotional festivities await.",
                        "organizer": {
                        "@type": "Organization",
                        "name": "ISKCON Vijayawada",
                        "url": "https://www.iskconvijayawada.org"
                        },
                        "offers": {
                        "@type": "Offer",
                        "url": "https://www.iskconvijayawada.org/rathyatra",
                        "price": "0",
                        "priceCurrency": "INR",
                        "availability": "https://schema.org/InStock",
                        "validFrom": "2025-06-15T00:00:00+05:30"
                        },
                        "performer": {
                        "@type": "Organization",
                        "name": "ISKCON Devotees"
                        }
                    }
                    `}
        </script> */}

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(eventSchema)}
        </script>
      </Helmet>
      <Hero />
      <TextContent />
      <JCarousel />
      <Form />
      <Qrcodes />
      <Footer />
    </div>
  );
};

export default Kartik2025;
